export function langSwitcher() {
    const _document = this._document;
    const mainHeader = _document.querySelector(".main-header");
    const langSwitcher = mainHeader.querySelector(".lang-switcher");
    const langPopup = mainHeader.querySelector(".lang-popup");
    const toggleBtnDesktop = mainHeader.querySelector(".toggle-switcher-btn");
    const toggleBtnMobile = langSwitcher.querySelector(".toggle-switcher-btn");
    const closePopup = langPopup.querySelector(".close-lang-popup");
    const langSwitch = langPopup.querySelector("li a");

    toggleBtnMobile.addEventListener("click", () => {
        langPopup.classList.toggle("active");
    });

    closePopup.addEventListener("click", () => {
        langPopup.classList.remove("active");
    });

    toggleBtnDesktop.addEventListener("click", () => {
        langPopup.classList.toggle("active");
        langSwitch.focus(); 
    });

    toggleBtnDesktop.addEventListener("mouseenter", () => {
        langPopup.classList.add("active");
        langSwitch.focus(); 
    });

    toggleBtnDesktop.addEventListener("mouseleave", () => {
        langPopup.classList.remove("active");
    });

    langPopup.addEventListener("mouseenter", () => {
        langPopup.classList.add("active");
    });

    langPopup.addEventListener("mouseleave", () => {
        langPopup.classList.remove("active");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/lang-switcher.js